import { Component, inject, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CONSENT_PARAM } from '@core/jss-seo';
import { NgClass } from '@angular/common';
import { GenericLinkDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-video-fallback',
  templateUrl: './video-fallback.component.html',
  standalone: true,
  imports: [NgClass, GenericLinkDirective],
})
export class VideoFallbackComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) aspectRatio!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() imageUrl?: SafeResourceUrl;

  readonly #activatedRoute = inject(ActivatedRoute);

  get currentURL() {
    return this.#activatedRoute.snapshot.url.join('/');
  }

  get queryString() {
    const params = new URLSearchParams();
    params.set(CONSENT_PARAM, 'true');
    return params.toString();
  }
}
